function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Bundled with Packemon: https://packemon.dev
// Platform: browser, Support: stable, Format: esm

import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Cookies from 'js-cookie';
import { ActionType, ComponentType } from '@cbhq/client-analytics';
import { jsxs, jsx } from 'react/jsx-runtime';
const CONSENT_PREFERENCES_COOKIE = 'cb_consent_preferences';
const CATEGORY_TO_CONSENT_MAP = {
  necessary: 'C0001',
  performance: 'C0002',
  functional: 'C0003',
  targeting: 'C0004'
};

// Constants for polling intervals
const ONETRUST_SYNC_INTERVAL = 200;
const ONETRUST_CALLBACK_INTERVAL = 100;
const COOKIE_EXPIRY_DAYS = 365;
const ONETRUST_LOADED_EVENT = 'onetrustloaded';
function useHasMounted() {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasMounted = _useState2[0],
    setHasMounted = _useState2[1];
  useEffect(() => {
    setHasMounted(true);
  }, []);
  return hasMounted;
}

/**
 * Helper function to build optimized category from tracker list
 */
function buildOptimizedCategory(id, trackers, required) {
  const exactMatches = new Set();
  const regexMatches = [];
  for (const tracker of trackers) {
    if (tracker.regex) {
      try {
        regexMatches.push({
          id: tracker.id,
          regex: tracker.regex,
          compiledRegex: new RegExp(tracker.regex)
        });
      } catch (error) {
        // Intentionally ignore invalid regex patterns
      }
    } else {
      exactMatches.add(tracker.id);
    }
  }
  return {
    id,
    required,
    exactMatches,
    regexMatches
  };
}

/**
 * Base.org cookie configuration
 */
const BaseCookieManagerConfig = {
  categories: new Map([['necessary', buildOptimizedCategory('necessary', [{
    // Used to speed up app loading time
    id: 'cached_locale'
  }, {
    // Used for security, maintained by Cloudflare
    id: '__cfduid'
  }, {
    // Coinbase Device marker, used to identify user's device
    id: 'cb_dm'
  }, {
    // Coinbase OAuth cookie for session handling
    id: 'unified-oauth-state-cookie'
  }, {
    // Used for authentication
    id: 'login-session'
  }, {
    // Used for device fingerprinting
    id: 'df3'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_commerce'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_exchange'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_insto'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_intx'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_prime'
  }, {
    // Used for identifying production issue on clients through Cloudflare
    id: 'cf_chl_rc_m'
  }, {
    // Used for Monorail session management
    id: '_x_flow_session'
  }, {
    // Used for preventing fraud by identifying devices
    id: '_immortal|deviceToken'
  }, {
    // Used for Google Recaptcha
    id: '_GRECAPTCHA'
  }, {
    // Cloudfare load-balancing, deliverance of website content, and serving DNS connections
    id: '__cfruid'
  }, {
    // Used for authentication
    id: 'oauth-state-cookie'
  }, {
    // Used to determine which country a given ip address is from
    id: 'ip_country'
  }, {
    // Allow the Cloudflare to distinguish individual users who share the same IP address
    id: '_cfuvid'
  }, {
    // Coinbase CDS FeatureFlagProvider that allows us to configure which feature flags are turned on via a the 'cds-ffs' cookie. Users will only have access to specific features under the flag.
    id: 'cds-ffs'
  }, {
    // Session token used to see if we already have a valid login session for current user. This is necessary for users to login.
    id: 'cc_dashboard_session'
  }, {
    // Get locale for user for translations, e.g en-US. This remembers preset locale languge for personalization.
    id: 'cc_locale_flag'
  }, {
    // Used for routing users
    id: 'logged_in'
  }, {
    // Used as a session sync cookie
    id: 'cb-gssc_development'
  }, {
    // Used as a session sync cookie
    id: 'cb-gssc_staging'
  }, {
    // Used as a session sync cookie
    id: 'cb-gssc'
  }, {
    // Used for security
    id: '_coinbase_session'
  }, {
    // Used for Privacy
    id: 'advertising_sharing_allowed'
  }, {
    // Used for security
    id: '__ssid'
  }, {
    // Used for security
    id: 'cf_ob_info'
  }, {
    // Used for security and fraud
    id: 'df2'
  }, {
    // Used for security and fraud
    id: 'df'
  }, {
    // Used for security and fraud
    id: 'ba'
  }, {
    // Used for security
    id: 'cf_use_ob'
  }, {
    // Used for security
    id: '_coinbase_lax'
  }, {
    // Used for security
    id: '_coinbase_strict'
  }, {
    // Used for authentication
    id: 'jwt'
  }, {
    // Used for authentication
    id: 'unified-session-manager-cookie'
  }, {
    // Used for second factor security
    id: 'sft'
  }, {
    // Used for japan testing
    id: 'japan_bespoke_content'
  }, {
    // This cookie is necessary for the proper functioning of bot solutions, that identify and mitigate automated traffic to protect your site from bad bots. This cookie lasts 1 session
    // Source: https://support.cloudflare.com/hc/en-us/articles/200170156-Understanding-the-Cloudflare-Cookies
    id: '__cf_bm'
  }, {
    // Persists the CB-CLIENT header for use in webviews; identifies the
    // mobile app the request comes from and the version of that app.
    id: 'CB-CLIENT'
  }, {
    // Used to test if cookies are enabled in browser
    id: 'cb_test_cookie'
  }, {
    // Required for the mobile app to communicate its cookie policy.
    id: 'is_mobile_app'
  }, {
    id: 'OptanonConsent'
    // Used for OneTrust consent management
  }, {
    id: 'OptanonAlertBoxClosed'
    // Used for OneTrust consent management
  }, {
    id: 'cb_consent_preferences'
    // Used for Coinbase consent preferences
  }, {
    id: 'cb_consent_signature'
    // Used for Coinbase consent signature
  }], true)], ['performance', buildOptimizedCategory('performance', [{
    id: '_gat'
    // This cookie name is associated with Google Universal Analytics, according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites. It expires after 10 minutes.',
  }, {
    id: '_gat_gtag_'
    // Google Analytics
  }, {
    id: '_gat_gtag_UA_-regex',
    // Google Analytics, used for storing unique user id.
    regex: '_gat_gtag_UA_[0-9]+_[0-9]+'
  }, {
    id: '_gat_UA-regex',
    // This cookie name is associated with Google Universal Analytics, according to documentation it is used for statistics.',
    regex: '_gat_UA-([0-9]{8})-([0-9]{2})'
  }, {
    id: 'cb-rfm'
    // Used to for consistent DB reads
  }, {
    id: 'ajs_anonymous_id'
    // These cookies are generally used for Analytics and help count how many people visit a certain site by tracking if you have visited before. This cookie has a lifespan of 1 year.
  }, {
    id: '__tld__'
    // Usage Trends
  }, {
    id: 'ajs%3Acookies'
    // This cookie supports use, service performance, and functionality of websites. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'ajs%3Atest'
    // This performance cookie counts visits and tracks other website traffic-related metrics. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'ajs_group_id'
    // These cookies track visitor usage and events within the website. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'coinbase_device_id'
    // Used for experimentation bucketing
  }, {
    id: 'amplitude_device_id'
    // Used for experimentation bucketing (deprecated)
  }, {
    id: '_gac_UA-regex',
    // This cookie name is associated with Google Universal Analytics, according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites.',
    regex: '_gac_UA-[0-9]+-[0-9]+'
  }, {
    id: 'JSESSIONID'
    // This domain is controlled by New Relic, which provides a platform for monitoring the performance of web and mobile applications.
  }, {
    id: 'cf_chl_rc_i'
    // This cookie is for internal use which allows Cloudflare to identify production issues on clients. This cookie has a lifespan of 1 session.
    // Source: https://support.cloudflare.com/hc/en-us/articles/200170156-Understanding-the-Cloudflare-Cookies
  }, {
    id: 'dtcookie'
    // This cookie is used to identify user sessions. This cookie is valid as long as the browser process is running.
    // Source: https://www.dynatrace.com/support/doc/appmon/user-experience-management/user-experience-management-administration/firewall-constraints-for-uem/
  }, {
    id: 'perf_dv5'
    // This cookie contains information to help distinguish users from the page. Gathers data about user visits, such as which pages are relevant. This cookie lasts 1 day
    // Source: http://www.allreballing.it/privacy-cookie/
  }, {
    id: 'rl_anonymous_id'
    // This cookie stores rl_anonymous_id , and attaches to every subsequent event. Helps identify users from other sites that hosted under a sub-domain. This cookie lasts 1 year
    // Source: https://docs.rudderstack.com/stream-sources/rudderstack-sdk-integration-guides/sdk-faqs
  }, {
    id: 'rl_user_id'
    // This cookie stores user with your application's unique identifier like email, database ID etc and  attaches to every event. This cookie lasts 1 year.
    // Source: https://docs.rudderstack.com/stream-sources/rudderstack-sdk-integration-guides/rudderstack-javascript-sdk
  }, {
    id: 'rl_group_id'
    // This cookie collects user activity on the web. This cookie lasts 1 year.
    // Source: https://docs.rudderstack.com/stream-sources/rudderstack-sdk-integration-guides/rudderstack-javascript-sdk
  }, {
    id: 'AMCV_regex',
    // This cookie stores a unique visitor ID and lets the ID service track visitors across your different domains and enable data sharing among different Experience Cloud solutions. This cookie expires after 2 years.
    // Source: https://experienceleague.adobe.com/docs/core-services/interface/administration/ec-cookies/cookies-mc.html?lang=en
    regex: 'AMCV_(?:[0-9A-Z]+)@AdobeOrg'
  }, {
    id: 'LPVID'
    // This cookie prvides a visitor ID as identified in Conversational Cloud. Identifies a browser as long as cookie is not deleted. This cookie lasts 1 year.
    // Source: https://developers.liveperson.com/cookies-and-conversational-cloud-overview.html
  }, {
    id: '__profilin'
    // Developer only, used by rack-mini-profiler to bypass work. This cookie lasts for the session.
    // Source: https://www.rubydoc.info/gems/rack-mini-profiler/0.9.6/Rack/MiniProfiler/ClientSettings
  }, {
    id: 'amp_regex',
    // This cookie is used to keep track of a few bits of metadata for the SDK: A randomly generated device id, the current session id, the current user id if a user id is set, the last event time, a few sequence ids in order to sequence events and identifies correctly
    // Source: https://developers.amplitude.com/docs/advanced-settings
    regex: 'amp_[0-9a-z]{6}'
  }, {
    id: 'LPSID-regex',
    // This cookie tracks the current active (or last) monitoring session. This cookie lasts a session.
    // Source: https://developers.liveperson.com/cookies-and-conversational-cloud-overview.html
    regex: 'LPSID-[0-9]+'
  }, {
    id: '_hp2_id.regex',
    // This cookie collects information to measure and understand how visitors use our Site. This includes user activity tracking on this Site, including pages visited and links clicked. This cookie lasts 1 day - 2 years.
    // Source: https://help.heap.io/data-privacy/data-privacy-faqs/what-cookies-does-heap-set-and-what-are-they-used-for/
    regex: '_hp2_id.[0-9]+'
  }, {
    id: '__utma'
    // This cookie is used to distinguish users and sessions. The cookie is created when the javascript library executes and no existing __utma cookies exists. The cookie is updated every time data is sent to Google Analytics. This cookie lasts 2 years.
    // Source: https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
  }, {
    id: 'x-login-id'
    // Persisted header in webviews. Tracks specific login attempts and is
    // used to correlate logs. It is short lived and renewed with each
    // login attempt.
  }, {
    id: 'x-uuid'
    // Persisted header in webviews. Device identifier for login purpose.
    // Likely to be cleaned up in the future when we have a clearer
    // strategy on that since other cookies like cb-fp2 serve a similar
    // purpose.
  }])], ['functional', buildOptimizedCategory('functional', [{
    id: 'cb_logged_out_locale'
    // Used for persisting logged out customer locale. Sets default logged out locale (language-country)',
  }, {
    id: 'coinbase_currency'
    // Used for persisting customer's preferred fiat currency.
  }, {
    id: '_parsely_visitor'
    // This cookie is used to determine if the visitor has visited the website before, or if it is a new visitor on the website.
  }, {
    id: 'advanced_color_theme'
    // Used to remember the theme preference of a user in advanced mode.
  }, {
    id: 'cb_spectrum'
    // Used for theme syncing across all Coinbase products.
  }, {
    id: 'hide_advanced_mode_nux'
    // Used to remember if the user dismissed the Advanced mode NUX modal
  }, {
    id: 'futures_hide_first_trade_onboarding_spotlight'
    // This cookie is used to track if the user has seen the first trade onboarding spotlight
  }, {
    id: 'futures_hide_after_first_trade_spotlight'
    // This cookie is used to track if the user has seen the after first trade spotlight
  }, {
    id: 'has_seen_perpetual_margin_health_banner_regex',
    regex: 'has_seen_perpetual_margin_health_banner_(.*)'
  }, {
    id: 'has_seen_advanced_mode_tooltip'
    // Used to determine whether to show an advanced mode user how to toggle between simple --> advanced
  }, {
    id: 'hide_usdc_banner'
    // Used to determine if the user dismissed the Trade with USDC banner on the Market Selector
  }, {
    id: 'has_seen_order_form_nux_tooltip'
    // Used to remember if the user has seen the tooltip explaining the changed order form options.
  }, {
    id: 'has_seen_advanced_fees_pricing_banner'
    // Used to determine whether an eligible advanced trader should be shown a banner elucidating a new fee structure
  }, {
    id: 'has_seen_zero_fee_incentive_banner'
    // Short term cookie being used to prevent upsell from display again after dismissed. For future projects, team has been alerted to use the upsell framework instead.
  }, {
    id: 'has_submitted_prime_resources_interest_form'
    // Used to determine whether a user has submitted prime resources interest form.
  }, {
    id: 'has_submitted_leadgen_form'
    // Used to determine whether a user has submitted leadgen form.
  }, {
    id: 'price_chart_resolution'
    // Used to preserve the user's trading view on Advanced Trade, also used to allow for prefetching some requests regarding the price chart
  }, {
    id: 'optimizelyEndUserId'
    // Optimizely places this for web experimentation and personalization',
  }, {
    id: 'coinbase_locale'
    // Used for persisting customer locale. Sets default locale/language',
  }, {
    id: 'hide_country_banner'
    // Used to check if country banner has been dismissed',
  }, {
    id: 'hide_cookies_message'
    // This performance cookie counts visits and tracks other website traffic-related metrics. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'hide_android_banner'
    // For hiding the android banner
  }, {
    id: 'plaid_oauth_data'
    // Used to identify returning users during the Plaid oauth flow
  }, {
    id: 'bytes_signup_modal_viewed'
    // determines if the user has already seen the global bytes signup modal
  }, {
    id: 'rlm_asset_page_view_count'
    // Keeps count of the asset page views which is used for the asset page rate limit modal
  }, {
    id: 'rlm_home_page_view_count'
    // Keeps count of the asset page views which is used for the home page rate limit modal
  }, {
    id: 'rlm_converter_page_view_count'
    // Keeps count of the converter page views which is used for the converter page rate limit modal
  }, {
    id: 'rlm_dismissed_asset'
    // Used to track if a user has dismissed the rate limit modal on the asset page
  }, {
    id: 'rlm_dismissed_home'
    // Used to track if a user has dismissed the rate limit modal on the home page
  }, {
    id: 'rlm_dismissed_converter'
    // Used to track if a user has dismissed the rate limit modal on the converter page
  }, {
    id: 'signup_modal_dismissed_home'
    // determines if the user has dismissed the signup modal on home page
  }, {
    id: 'signup_modal_dismissed_learn'
    // determines if the user has dismissed the signup modal on learn page
  }, {
    id: 'has_seen_fee_upgrade_banner'
    // Used to track if the user has already seen and dismissed the fee upgrade banner
  }, {
    id: 'paypal_reauth_data'
    // Used to identify returning users during the Paypal reauth flow
  }, {
    id: 'cb-sut'
    // Magic cookie for smart routing on staging and dev to fetch frontend build from candidate s3 bucket instead of canonical dev or staging s3 bucket
  }, {
    id: 'hide_hc_country_banner'
    // Used to check if country banner has been dismissed',
  }])], ['targeting', buildOptimizedCategory('targeting', [{
    id: 'user_agent'
    // Used for attributing paid marketing
  }, {
    id: '_ga'
    // This cookie name is associated with Google Universal Analytics - which is a significant update to Google's more commonly used analytics service. This cookie is used to distinguish unique users by assigning a randomly generated number as a client identifier. It is included in each page request in a site and used to calculate visitor, session and campaign data for the sites analytics reports.  By default it is set to expire after 2 years, although this is customisable by website owners.
  }, {
    id: '_ga_regex',
    // This cookie name is associated with Google Analytics (GA + web tag), according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites.',
    regex: '_ga_[a-zA-Z0-9]{10}'
  }, {
    id: '_gid'
    // This cookie name is asssociated with Google Universal Analytics. This appears to be a new cookie and as of Spring 2017 no information is available from Google.  It appears to store and update a unique value for each page visited.
  }, {
    id: 'utm'
    // Used for attributing paid marketing
  }, {
    id: 'utm_raw'
    // Used for attributing paid marketing
  }, {
    id: 'li_fat_id'
    // This cookie is used to pass back conversion events to LinkedIn after user goes through Unified Signup.
  }, {
    id: 'rdt_cid'
    // This cookie is used to pass back conversion events to Reddit after user goes through Unified Signup.
  },
  // First party
  {
    id: 'gclid'
    // Used for attributing Google marketing
  }, {
    id: '_uetvid'
    // Store and track activity across websites
  }, {
    id: '_uetsid'
    // Store and track activity across websites
  }, {
    id: 'MUID'
    // Store and track activity across websites
  }, {
    id: 'fbclid'
    // Used for attributing Facebook marketing
  }, {
    id: '_gcl_au'
    // Used by google tag manager
  },
  // Third party
  {
    id: '_fbc'
    // Used for attributing Facebook marketing
  }, {
    id: '_fbp'
    // Used for attributing Facebook marketing
  }, {
    id: 'wd'
    // Used for attributing Facebook marketing
  }, {
    id: 'dpr'
    // Used for attributing Facebook marketing
  }, {
    id: 'act'
    // Used for attributing Facebook marketing
  }, {
    id: 'c_user'
    // Used for attributing Facebook marketing
  }, {
    id: 'presence'
    // Used for attributing Facebook marketing
  }, {
    id: 'sb'
    // Used for attributing Facebook marketing
  }, {
    id: 'xs'
    // Used for attributing Facebook marketing
  }, {
    id: 'spin'
    // Used for attributing Facebook marketing
  }, {
    id: 'datr'
    // Used for attributing Facebook marketing
  }, {
    id: 'YSC'
    // YouTube is a Google owned platform for hosting and sharing videos. YouTube collects user data through videos embedded in websites, which is aggregated with profile data from other Google services in order to display targeted advertising to web visitors across a broad range of their own and other websites.',
  }, {
    id: 'VISITOR_INFO1_LIVE'
    // This cookie is ownded by Youtube and used as a unique identifier to track viewing of videos',
  }, {
    id: 'amplitude_id-regex',
    // This cookie is from Amplitude for tracking users
    regex: 'amplitude_id(?:_[a-f0-9]{32}|undefined)(?:.*)'
  }, {
    id: 'ATN'
    // This domain is owned by Atlas Solutions which is in turn owned by Facebook. Atlas is an online advertising business, targeting users through tracking their web activity. From September 2014 the company re-launched under the ownership of Facebook, promising the ability to reach known users and target adverts based on profiles generated using Facebook's user data.",
  }, {
    id: 'NID'
    // This domain is owned by Google Inc. Although Google is primarily known as a search engine, the company provides a diverse range of products and services. Its main source of revenue however is advertising. Google tracks users extensively both through its own products and sites, and the numerous technologies embedded into many millions of websites around the world. It uses the data gathered from most of these services to profile the interests of web users and sell advertising space to organisations based on such interest profiles as well as aligning adverts to the content on the pages where its customer's adverts appear.",
  }, {
    id: 'GPS'
    // YouTube is a Google owned platform for hosting and sharing videos. YouTube collects user data through videos embedded in websites, which is aggregated with profile data from other Google services in order to display targeted advertising to web visitors across a broad range of their own and other websites.',
  }, {
    id: 'AA003'
    // This domain is owned by Atlas Solutions which is in turn owned by Facebook. Atlas is an online advertising business, targeting users through tracking their web activity. From September 2014 the company re-launched under the ownership of Facebook, promising the ability to reach known users and target adverts based on profiles generated using Facebook's user data.",
  }, {
    id: 'mp_regex',
    // Cookie is placed by Mixpanel. Mixpanel is a company that produces user behavior analytics.',
    regex: 'mp_[a-f0-9]{32}_mixpanel'
  }, {
    id: 'gcl'
    // Ads targeting for Google and conversion tracking
  }, {
    id: 'msclkid'
    // Ads targeting for Microsoft and conversion tracking
  }, {
    id: 'ptclid'
    // Ads targeting for Pinterest and conversion tracking
  }, {
    id: 'ttclid'
    // Ads targeting for TikTok and conversion tracking
  }, {
    id: '_gcl_aw'
    // This cookie functions to store ad click information (only if remarketing cookies are enabled), generate unique IDs for visitors to remember preferences and track and gather statistics and conversion rates through the website. It expires after 90 days.
    // Source: https://support.google.com/tagmanager/answer/7549390?hl=en
  }, {
    id: 'iterableTemplateId'
    // This cookie contains a unique ID associated with the email's template in Iterable. This cookie expires in one day.
    // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
  }, {
    id: 'iterableMessageId'
    // This cookie contains a unique ID associated with a specific send of a specific Iterable campaign to a specific user. If the same user ever receives the same campaign more than once, each will have a unique iterableMessageId. This cookie expires in one day.
    // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
  }, {
    id: 'iterableEndUserId'
    // This cookie contains the recipient's e-mail address. This cookie expires in one day.
    // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
  }, {
    id: 'iterableEmailCampaignId'
    // This cookie contains a unique ID associated with the email's campaign in Iterable. This cookie expiresin one day.
    // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
  }, {
    id: '_gac_gb_regex',
    // This cookie contains campaign related information. This cookie exists for 90 days.
    // Source: https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
    regex: '_gac_gb_[0-9A-Z-]+'
  }])], ['delete-if-seen', buildOptimizedCategory('delete-if-seen', [{
    id: 'cloudflare-challenge-regex',
    // These cookies are used by Cloudflare for the execution of
    // Javascript or Captcha challenges. They are not used for tracking or
    // beyond the scope of the challenge. They can be deleted if seen.
    regex: '^(cf_chl_prog$)|(cf_cc_...$)|(cf_chl_cc_...$)|(cf_chl_seq_...$)'
  }])]]),
  geolocationRules: [{
    region: 'DEFAULT',
    framework: 'optOut'
  }, {
    region: 'EU',
    framework: 'optIn'
  }]
};

/**
 * Retail Coinbase-www cookie configuration
 */
const CoinbaseCookieManagerConfig = {
  categories: new Map([['necessary', buildOptimizedCategory('necessary', [{
    // Used to speed up app loading time
    id: 'cached_locale'
  }, {
    // Used for security, maintained by Cloudflare
    id: '__cfduid'
  }, {
    // Coinbase Device marker, used to identify user's device
    id: 'cb_dm'
  }, {
    // Coinbase OAuth cookie for session handling
    id: 'unified-oauth-state-cookie'
  }, {
    // Used for authentication
    id: 'login-session'
  }, {
    // Used for device fingerprinting
    id: 'df3'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_commerce'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_exchange'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_insto'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_intx'
  }, {
    // Used in auto session detection to avoid infinite loops
    id: 'no_redirect_prime'
  }, {
    // Used for identifying production issue on clients through Cloudflare
    id: 'cf_chl_rc_m'
  }, {
    // Used for Monorail session management
    id: '_x_flow_session'
  }, {
    // Used for preventing fraud by identifying devices
    id: '_immortal|deviceToken'
  }, {
    // Used for Google Recaptcha
    id: '_GRECAPTCHA'
  }, {
    // Cloudfare load-balancing, deliverance of website content, and serving DNS connections
    id: '__cfruid'
  }, {
    // Used for authentication
    id: 'oauth-state-cookie'
  }, {
    // Used to determine which country a given ip address is from
    id: 'ip_country'
  }, {
    // Allow the Cloudflare to distinguish individual users who share the same IP address
    id: '_cfuvid'
  }, {
    // Coinbase CDS FeatureFlagProvider that allows us to configure which feature flags are turned on via a the 'cds-ffs' cookie. Users will only have access to specific features under the flag.
    id: 'cds-ffs'
  }, {
    // Session token used to see if we already have a valid login session for current user. This is necessary for users to login.
    id: 'cc_dashboard_session'
  }, {
    // Get locale for user for translations, e.g en-US. This remembers preset locale languge for personalization.
    id: 'cc_locale_flag'
  }, {
    // Used for routing users
    id: 'logged_in'
  }, {
    // Used as a session sync cookie
    id: 'cb-gssc_development'
  }, {
    // Used as a session sync cookie
    id: 'cb-gssc_staging'
  }, {
    // Used as a session sync cookie
    id: 'cb-gssc'
  }, {
    // Used for security
    id: '_coinbase_session'
  }, {
    // Used for Privacy
    id: 'advertising_sharing_allowed'
  }, {
    // Used for security
    id: '__ssid'
  }, {
    // Used for security
    id: 'cf_ob_info'
  }, {
    // Used for security and fraud
    id: 'df2'
  }, {
    // Used for security and fraud
    id: 'df'
  }, {
    // Used for security and fraud
    id: 'ba'
  }, {
    // Used for security
    id: 'cf_use_ob'
  }, {
    // Used for security
    id: '_coinbase_lax'
  }, {
    // Used for security
    id: '_coinbase_strict'
  }, {
    // Used for authentication
    id: 'jwt'
  }, {
    // Used for authentication
    id: 'unified-session-manager-cookie'
  }, {
    // Used for second factor security
    id: 'sft'
  }, {
    // Used for japan testing
    id: 'japan_bespoke_content'
  }, {
    // This cookie is necessary for the proper functioning of bot solutions, that identify and mitigate automated traffic to protect your site from bad bots. This cookie lasts 1 session
    // Source: https://support.cloudflare.com/hc/en-us/articles/200170156-Understanding-the-Cloudflare-Cookies
    id: '__cf_bm'
  }, {
    // Persists the CB-CLIENT header for use in webviews; identifies the
    // mobile app the request comes from and the version of that app.
    id: 'CB-CLIENT'
  }, {
    // Used to test if cookies are enabled in browser
    id: 'cb_test_cookie'
  }, {
    // Required for the mobile app to communicate its cookie policy.
    id: 'is_mobile_app'
  }, {
    id: 'OptanonConsent'
    // Used for OneTrust consent management
  }, {
    id: 'OptanonAlertBoxClosed'
    // Used for OneTrust consent management
  }, {
    id: 'cb_consent_preferences'
    // Used for Coinbase consent preferences
  }, {
    id: 'cb_consent_signature'
    // Used for Coinbase consent signature
  }, {
    id: 'coinbase_device_id'
    // Used for Phone Verified Sign-ups, experimentation bucketing and Page view analytics by multiple teams
    // Also used by services like Unified login, Janus for critical device fingerprinting and rate limiting on server side
  }], true)], ['performance', buildOptimizedCategory('performance', [{
    id: '_gat'
    // This cookie name is associated with Google Universal Analytics, according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites. It expires after 10 minutes.',
  }, {
    id: '_gat_gtag_'
    // Google Analytics
  }, {
    id: '_gat_gtag_UA_-regex',
    // Google Analytics, used for storing unique user id.
    regex: '_gat_gtag_UA_[0-9]+_[0-9]+'
  }, {
    id: '_gat_UA-regex',
    // This cookie name is associated with Google Universal Analytics, according to documentation it is used for statistics.',
    regex: '_gat_UA-([0-9]{8})-([0-9]{2})'
  }, {
    id: 'cb-rfm'
    // Used to for consistent DB reads
  }, {
    id: 'ajs_anonymous_id'
    // These cookies are generally used for Analytics and help count how many people visit a certain site by tracking if you have visited before. This cookie has a lifespan of 1 year.
  }, {
    id: '__tld__'
    // Usage Trends
  }, {
    id: 'ajs%3Acookies'
    // This cookie supports use, service performance, and functionality of websites. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'ajs%3Atest'
    // This performance cookie counts visits and tracks other website traffic-related metrics. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'ajs_group_id'
    // These cookies track visitor usage and events within the website. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'amplitude_device_id'
    // Used for experimentation bucketing (deprecated)
  }, {
    id: '_gac_UA-regex',
    // This cookie name is associated with Google Universal Analytics, according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites.',
    regex: '_gac_UA-[0-9]+-[0-9]+'
  }, {
    id: 'JSESSIONID'
    // This domain is controlled by New Relic, which provides a platform for monitoring the performance of web and mobile applications.
  }, {
    id: 'cf_chl_rc_i'
    // This cookie is for internal use which allows Cloudflare to identify production issues on clients. This cookie has a lifespan of 1 session.
    // Source: https://support.cloudflare.com/hc/en-us/articles/200170156-Understanding-the-Cloudflare-Cookies
  }, {
    id: 'dtcookie'
    // This cookie is used to identify user sessions. This cookie is valid as long as the browser process is running.
    // Source: https://www.dynatrace.com/support/doc/appmon/user-experience-management/user-experience-management-administration/firewall-constraints-for-uem/
  }, {
    id: 'perf_dv5'
    // This cookie contains information to help distinguish users from the page. Gathers data about user visits, such as which pages are relevant. This cookie lasts 1 day
    // Source: http://www.allreballing.it/privacy-cookie/
  }, {
    id: 'rl_anonymous_id'
    // This cookie stores rl_anonymous_id , and attaches to every subsequent event. Helps identify users from other sites that hosted under a sub-domain. This cookie lasts 1 year
    // Source: https://docs.rudderstack.com/stream-sources/rudderstack-sdk-integration-guides/sdk-faqs
  }, {
    id: 'rl_user_id'
    // This cookie stores user with your application's unique identifier like email, database ID etc and  attaches to every event. This cookie lasts 1 year.
    // Source: https://docs.rudderstack.com/stream-sources/rudderstack-sdk-integration-guides/rudderstack-javascript-sdk
  }, {
    id: 'rl_group_id'
    // This cookie collects user activity on the web. This cookie lasts 1 year.
    // Source: https://docs.rudderstack.com/stream-sources/rudderstack-sdk-integration-guides/rudderstack-javascript-sdk
  }, {
    id: 'AMCV_regex',
    // This cookie stores a unique visitor ID and lets the ID service track visitors across your different domains and enable data sharing among different Experience Cloud solutions. This cookie expires after 2 years.
    // Source: https://experienceleague.adobe.com/docs/core-services/interface/administration/ec-cookies/cookies-mc.html?lang=en
    regex: 'AMCV_(?:[0-9A-Z]+)@AdobeOrg'
  }, {
    id: 'LPVID'
    // This cookie prvides a visitor ID as identified in Conversational Cloud. Identifies a browser as long as cookie is not deleted. This cookie lasts 1 year.
    // Source: https://developers.liveperson.com/cookies-and-conversational-cloud-overview.html
  }, {
    id: '__profilin'
    // Developer only, used by rack-mini-profiler to bypass work. This cookie lasts for the session.
    // Source: https://www.rubydoc.info/gems/rack-mini-profiler/0.9.6/Rack/MiniProfiler/ClientSettings
  }, {
    id: 'amp_regex',
    // This cookie is used to keep track of a few bits of metadata for the SDK: A randomly generated device id, the current session id, the current user id if a user id is set, the last event time, a few sequence ids in order to sequence events and identifies correctly
    // Source: https://developers.amplitude.com/docs/advanced-settings
    regex: 'amp_[0-9a-z]{6}'
  }, {
    id: 'LPSID-regex',
    // This cookie tracks the current active (or last) monitoring session. This cookie lasts a session.
    // Source: https://developers.liveperson.com/cookies-and-conversational-cloud-overview.html
    regex: 'LPSID-[0-9]+'
  }, {
    id: '_hp2_id.regex',
    // This cookie collects information to measure and understand how visitors use our Site. This includes user activity tracking on this Site, including pages visited and links clicked. This cookie lasts 1 day - 2 years.
    // Source: https://help.heap.io/data-privacy/data-privacy-faqs/what-cookies-does-heap-set-and-what-are-they-used-for/
    regex: '_hp2_id.[0-9]+'
  }, {
    id: '__utma'
    // This cookie is used to distinguish users and sessions. The cookie is created when the javascript library executes and no existing __utma cookies exists. The cookie is updated every time data is sent to Google Analytics. This cookie lasts 2 years.
    // Source: https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
  }, {
    id: 'x-login-id'
    // Persisted header in webviews. Tracks specific login attempts and is
    // used to correlate logs. It is short lived and renewed with each
    // login attempt.
  }, {
    id: 'x-uuid'
    // Persisted header in webviews. Device identifier for login purpose.
    // Likely to be cleaned up in the future when we have a clearer
    // strategy on that since other cookies like cb-fp2 serve a similar
    // purpose.
  }])], ['functional', buildOptimizedCategory('functional', [{
    id: 'cb_logged_out_locale'
    // Used for persisting logged out customer locale. Sets default logged out locale (language-country)',
  }, {
    id: 'coinbase_currency'
    // Used for persisting customer's preferred fiat currency.
  }, {
    id: '_parsely_visitor'
    // This cookie is used to determine if the visitor has visited the website before, or if it is a new visitor on the website.
  }, {
    id: 'advanced_color_theme'
    // Used to remember the theme preference of a user in advanced mode.
  }, {
    id: 'cb_spectrum'
    // Used for theme syncing across all Coinbase products.
  }, {
    id: 'hide_advanced_mode_nux'
    // Used to remember if the user dismissed the Advanced mode NUX modal
  }, {
    id: 'futures_hide_first_trade_onboarding_spotlight'
    // This cookie is used to track if the user has seen the first trade onboarding spotlight
  }, {
    id: 'futures_hide_after_first_trade_spotlight'
    // This cookie is used to track if the user has seen the after first trade spotlight
  }, {
    id: 'has_seen_perpetual_margin_health_banner_regex',
    regex: 'has_seen_perpetual_margin_health_banner_(.*)'
  }, {
    id: 'has_seen_advanced_mode_tooltip'
    // Used to determine whether to show an advanced mode user how to toggle between simple --> advanced
  }, {
    id: 'hide_usdc_banner'
    // Used to determine if the user dismissed the Trade with USDC banner on the Market Selector
  }, {
    id: 'has_seen_order_form_nux_tooltip'
    // Used to remember if the user has seen the tooltip explaining the changed order form options.
  }, {
    id: 'has_seen_advanced_fees_pricing_banner'
    // Used to determine whether an eligible advanced trader should be shown a banner elucidating a new fee structure
  }, {
    id: 'has_seen_zero_fee_incentive_banner'
    // Short term cookie being used to prevent upsell from display again after dismissed. For future projects, team has been alerted to use the upsell framework instead.
  }, {
    id: 'has_submitted_prime_resources_interest_form'
    // Used to determine whether a user has submitted prime resources interest form.
  }, {
    id: 'has_submitted_leadgen_form'
    // Used to determine whether a user has submitted leadgen form.
  }, {
    id: 'price_chart_resolution'
    // Used to preserve the user's trading view on Advanced Trade, also used to allow for prefetching some requests regarding the price chart
  }, {
    id: 'optimizelyEndUserId'
    // Optimizely places this for web experimentation and personalization',
  }, {
    id: 'coinbase_locale'
    // Used for persisting customer locale. Sets default locale/language',
  }, {
    id: 'hide_country_banner'
    // Used to check if country banner has been dismissed',
  }, {
    id: 'hide_cookies_message'
    // This performance cookie counts visits and tracks other website traffic-related metrics. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'hide_android_banner'
    // For hiding the android banner
  }, {
    id: 'plaid_oauth_data'
    // Used to identify returning users during the Plaid oauth flow
  }, {
    id: 'bytes_signup_modal_viewed'
    // determines if the user has already seen the global bytes signup modal
  }, {
    id: 'rlm_asset_page_view_count'
    // Keeps count of the asset page views which is used for the asset page rate limit modal
  }, {
    id: 'rlm_home_page_view_count'
    // Keeps count of the asset page views which is used for the home page rate limit modal
  }, {
    id: 'rlm_converter_page_view_count'
    // Keeps count of the converter page views which is used for the converter page rate limit modal
  }, {
    id: 'rlm_dismissed_asset'
    // Used to track if a user has dismissed the rate limit modal on the asset page
  }, {
    id: 'rlm_dismissed_home'
    // Used to track if a user has dismissed the rate limit modal on the home page
  }, {
    id: 'rlm_dismissed_converter'
    // Used to track if a user has dismissed the rate limit modal on the converter page
  }, {
    id: 'signup_modal_dismissed_home'
    // determines if the user has dismissed the signup modal on home page
  }, {
    id: 'signup_modal_dismissed_learn'
    // determines if the user has dismissed the signup modal on learn page
  }, {
    id: 'has_seen_fee_upgrade_banner'
    // Used to track if the user has already seen and dismissed the fee upgrade banner
  }, {
    id: 'paypal_reauth_data'
    // Used to identify returning users during the Paypal reauth flow
  }, {
    id: 'cb-sut'
    // Magic cookie for smart routing on staging and dev to fetch frontend build from candidate s3 bucket instead of canonical dev or staging s3 bucket
  }, {
    id: 'hide_hc_country_banner'
    // Used to check if country banner has been dismissed',
  }])], ['targeting', buildOptimizedCategory('targeting', [{
    id: 'user_agent'
    // Used for attributing paid marketing
  }, {
    id: '_ga'
    // This cookie name is associated with Google Universal Analytics - which is a significant update to Google's more commonly used analytics service. This cookie is used to distinguish unique users by assigning a randomly generated number as a client identifier. It is included in each page request in a site and used to calculate visitor, session and campaign data for the sites analytics reports.  By default it is set to expire after 2 years, although this is customisable by website owners.
  }, {
    id: '_ga_regex',
    // This cookie name is associated with Google Analytics (GA + web tag), according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites.',
    regex: '_ga_[a-zA-Z0-9]{10}'
  }, {
    id: '_gid'
    // This cookie name is asssociated with Google Universal Analytics. This appears to be a new cookie and as of Spring 2017 no information is available from Google.  It appears to store and update a unique value for each page visited.
  }, {
    id: 'utm'
    // Used for attributing paid marketing
  }, {
    id: 'utm_raw'
    // Used for attributing paid marketing
  }, {
    id: 'li_fat_id'
    // This cookie is used to pass back conversion events to LinkedIn after user goes through Unified Signup.
  }, {
    id: 'rdt_cid'
    // This cookie is used to pass back conversion events to Reddit after user goes through Unified Signup.
  },
  // First party
  {
    id: 'gclid'
    // Used for attributing Google marketing
  }, {
    id: 'g_state'
    // Used to store the state of the GoogleOneTap modal in logged out wwww
  }, {
    id: '_uetvid'
    // Store and track activity across websites
  }, {
    id: '_uetsid'
    // Store and track activity across websites
  }, {
    id: 'MUID'
    // Store and track activity across websites
  }, {
    id: 'fbclid'
    // Used for attributing Facebook marketing
  }, {
    id: '_gcl_au'
    // Used by google tag manager
  },
  // Third party
  {
    id: '_fbc'
    // Used for attributing Facebook marketing
  }, {
    id: '_fbp'
    // Used for attributing Facebook marketing
  }, {
    id: 'wd'
    // Used for attributing Facebook marketing
  }, {
    id: 'dpr'
    // Used for attributing Facebook marketing
  }, {
    id: 'act'
    // Used for attributing Facebook marketing
  }, {
    id: 'c_user'
    // Used for attributing Facebook marketing
  }, {
    id: 'presence'
    // Used for attributing Facebook marketing
  }, {
    id: 'sb'
    // Used for attributing Facebook marketing
  }, {
    id: 'xs'
    // Used for attributing Facebook marketing
  }, {
    id: 'spin'
    // Used for attributing Facebook marketing
  }, {
    id: 'datr'
    // Used for attributing Facebook marketing
  }, {
    id: 'YSC'
    // YouTube is a Google owned platform for hosting and sharing videos. YouTube collects user data through videos embedded in websites, which is aggregated with profile data from other Google services in order to display targeted advertising to web visitors across a broad range of their own and other websites.',
  }, {
    id: 'VISITOR_INFO1_LIVE'
    // This cookie is ownded by Youtube and used as a unique identifier to track viewing of videos',
  }, {
    id: 'amplitude_id-regex',
    // This cookie is from Amplitude for tracking users
    regex: 'amplitude_id(?:_[a-f0-9]{32}|undefined)(?:.*)'
  }, {
    id: 'ATN'
    // This domain is owned by Atlas Solutions which is in turn owned by Facebook. Atlas is an online advertising business, targeting users through tracking their web activity. From September 2014 the company re-launched under the ownership of Facebook, promising the ability to reach known users and target adverts based on profiles generated using Facebook's user data.",
  }, {
    id: 'NID'
    // This domain is owned by Google Inc. Although Google is primarily known as a search engine, the company provides a diverse range of products and services. Its main source of revenue however is advertising. Google tracks users extensively both through its own products and sites, and the numerous technologies embedded into many millions of websites around the world. It uses the data gathered from most of these services to profile the interests of web users and sell advertising space to organisations based on such interest profiles as well as aligning adverts to the content on the pages where its customer's adverts appear.",
  }, {
    id: 'GPS'
    // YouTube is a Google owned platform for hosting and sharing videos. YouTube collects user data through videos embedded in websites, which is aggregated with profile data from other Google services in order to display targeted advertising to web visitors across a broad range of their own and other websites.',
  }, {
    id: 'AA003'
    // This domain is owned by Atlas Solutions which is in turn owned by Facebook. Atlas is an online advertising business, targeting users through tracking their web activity. From September 2014 the company re-launched under the ownership of Facebook, promising the ability to reach known users and target adverts based on profiles generated using Facebook's user data.",
  }, {
    id: 'mp_regex',
    // Cookie is placed by Mixpanel. Mixpanel is a company that produces user behavior analytics.',
    regex: 'mp_[a-f0-9]{32}_mixpanel'
  }, {
    id: 'gcl'
    // Ads targeting for Google and conversion tracking
  }, {
    id: 'msclkid'
    // Ads targeting for Microsoft and conversion tracking
  }, {
    id: 'ptclid'
    // Ads targeting for Pinterest and conversion tracking
  }, {
    id: 'ttclid'
    // Ads targeting for TikTok and conversion tracking
  }, {
    id: '_gcl_aw'
    // This cookie functions to store ad click information (only if remarketing cookies are enabled), generate unique IDs for visitors to remember preferences and track and gather statistics and conversion rates through the website. It expires after 90 days.
    // Source: https://support.google.com/tagmanager/answer/7549390?hl=en
  }, {
    id: 'iterableTemplateId'
    // This cookie contains a unique ID associated with the email's template in Iterable. This cookie expires in one day.
    // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
  }, {
    id: 'iterableMessageId'
    // This cookie contains a unique ID associated with a specific send of a specific Iterable campaign to a specific user. If the same user ever receives the same campaign more than once, each will have a unique iterableMessageId. This cookie expires in one day.
    // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
  }, {
    id: 'iterableEndUserId'
    // This cookie contains the recipient's e-mail address. This cookie expires in one day.
    // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
  }, {
    id: 'iterableEmailCampaignId'
    // This cookie contains a unique ID associated with the email's campaign in Iterable. This cookie expiresin one day.
    // Source: https://support.iterable.com/hc/en-us/articles/205480285-Tracking-Purchases-and-Revenue-#use-browser-cookies-set-by-iterable
  }, {
    id: '_gac_gb_regex',
    // This cookie contains campaign related information. This cookie exists for 90 days.
    // Source: https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
    regex: '_gac_gb_[0-9A-Z-]+'
  }])], ['delete-if-seen', buildOptimizedCategory('delete-if-seen', [{
    id: 'cloudflare-challenge-regex',
    // These cookies are used by Cloudflare for the execution of
    // Javascript or Captcha challenges. They are not used for tracking or
    // beyond the scope of the challenge. They can be deleted if seen.
    regex: '^(cf_chl_prog$)|(cf_cc_...$)|(cf_chl_cc_...$)|(cf_chl_seq_...$)'
  }])]]),
  geolocationRules: [{
    region: 'DEFAULT',
    framework: 'optOut'
  }, {
    region: 'EU',
    framework: 'optIn'
  }]
};

/**
 * Exchange Moonbase-www cookie configuration
 */
const ExchangeCookieManagerConfig = {
  categories: new Map([['necessary', buildOptimizedCategory('necessary', [{
    id: '__cfduid'
    // 'Used for security, maintained by Cloudflare',
  }, {
    id: '_cf_bm'
    // Cloudflare cookie, helps manage incoming traffic that matches criteria associated with bots
  }, {
    id: 'cf-country'
    // Used to deliver region-based cookie settings to logged out users
  }, {
    id: '_coinbase_session'
    // 'Used for security',
  }, {
    id: '__ssid'
    // 'Used for security',
  }, {
    id: 'df2'
    // 'Used for security and fraud',
  }, {
    id: 'df'
    // 'Used for security and fraud',
  }, {
    id: 'ba'
    // 'Used for security and fraud',
  }, {
    id: '_coinbase_lax'
    // 'Used for security',
  }, {
    id: '_coinbase_strict'
    // 'Used for security',
  }, {
    id: 'sft'
    // 'Used for second factor security',
  }], true)], ['performance', buildOptimizedCategory('performance', [{
    id: 'enable_performance_analytics'
    // 'Used for blocking google analytics when a user has not consented to targeting cookies',
  }, {
    id: 'cb-rfm'
    // 'Used to for consistent DB reads',
  }, {
    id: 'ajs_anonymous_id'
    // 'These cookies are generally used for Analytics and help count how many people visit a certain site by tracking if you have visited before. This cookie has a lifespan of 1 year.',
  }, {
    id: 'ajs%3Acookies'
    // 'This cookie supports use, service performance, and functionality of websites. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'ajs%3Atest'
    // 'This performance cookie counts visits and tracks other website traffic-related metrics. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'ajs_group_id'
    // 'These cookies track visitor usage and events within the website. Cookies in this domain have lifespan of 1 year.',
  }, {
    id: 'amplitude_device_id'
    // 'Used for experimentation bucketing (deprecated)',
  }, {
    id: 'coinbase_device_id'
    // 'Used for experimentation bucketing',
  }, {
    id: '_gat'
    // 'This cookie name is associated with Google Universal Analytics, according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites. It expires after 10 minutes.',
  }, {
    id: '_gac_UA-32804181-23'
    // 'This cookie name is associated with Google Universal Analytics, according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites.',
  }, {
    id: '_gid'
    // 'This cookie name is asssociated with Google Universal Analytics. This appears to be a new cookie and as of Spring 2017 no information is available from Google.  It appears to store and update a unique value for each page visited.',
  }, {
    id: '_ga'
    // "This cookie name is associated with Google Universal Analytics - which is a significant update to Google's more commonly used analytics service. This cookie is used to distinguish unique users by assigning a randomly generated number as a client identifier. It is included in each page request in a site and used to calculate visitor, session and campaign data for the sites analytics reports.  By default it is set to expire after 2 years, although this is customisable by website owners.",
  }, {
    id: 'JSESSIONID'
    // 'This domain is controlled by New Relic, which provides a platform for monitoring the performance of web and mobile applications.',
  }, {
    id: '_ga_regex',
    // 'This cookie name is associated with Google Analytics (GA + web tag), according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites.',
    regex: '_ga_[a-zA-Z0-9]{10}'
  }])], ['functional', buildOptimizedCategory('functional', [{
    id: '_parsely_visitor'
    // 'This cookie is used to determine if the visitor has visited the website before, or if it is a new visitor on the website.',
  }, {
    id: '_parsely_session'
    // 'This cookie is used to determine if the visitor has visited the website before, or if it is a new visitor on the website.',
  }, {
    id: 'optimizelyEndUserId'
    // 'Optimizely places this for web experimentation and personalization',
  }, {
    id: 'hide_android_banner'
    // 'For hiding the android banner',
  }])], ['targeting', buildOptimizedCategory('targeting', [
  // First party
  {
    id: 'enable_targeting_analytics'
    // 'Used for blocking amplitude analytics when a user has not consented to targeting cookies',
  }, {
    id: '_gcl_au'
    // 'Used by google tag manager',
  }, {
    id: 'utm'
    // 'Used for attributing paid marketing',
  },
  // Third party
  {
    id: 'fr'
    // 'Contains browser and user unique ID combinaton, used for targeted advertising.',
  }, {
    id: 'VISITOR_INFO1_LIVE'
    // 'This cookie is ownded by Youtube and used as a unique identifier to track viewing of videos',
  }, {
    id: 'amplitude_id-regex',
    // 'This cookie is from Amplitude for tracking users',
    regex: 'amplitude_id(?:_[a-f0-9]{32}|undefined)(?:.*)'
  }, {
    id: 'ATN'
    // "This domain is owned by Atlas Solutions which is in turn owned by Facebook. Atlas is an online advertising business, targeting users through tracking their web activity. From September 2014 the company re-launched under the ownership of Facebook, promising the ability to reach known users and target adverts based on profiles generated using Facebook's user data.",
  }, {
    id: 'NID'
    // "This domain is owned by Google Inc. Although Google is primarily known as a search engine, the company provides a diverse range of products and services. Its main source of revenue however is advertising. Google tracks users extensively both through its own products and sites, and the numerous technologies embedded into many millions of websites around the world. It uses the data gathered from most of these services to profile the interests of web users and sell advertising space to organisations based on such interest profiles as well as aligning adverts to the content on the pages where its customer's adverts appear.",
  }, {
    id: 'IDE'
    // 'This domain is owned by Doubleclick (Google). The main business activity is: Doubleclick is Googles real time bidding advertising exchange',
  }, {
    id: 'GPS'
    // 'YouTube is a Google owned platform for hosting and sharing videos. YouTube collects user data through videos embedded in websites, which is aggregated with profile data from other Google services in order to display targeted advertising to web visitors across a broad range of their own and other websites.',
  }, {
    id: 'AA003'
    // "This domain is owned by Atlas Solutions which is in turn owned by Facebook. Atlas is an online advertising business, targeting users through tracking their web activity. From September 2014 the company re-launched under the ownership of Facebook, promising the ability to reach known users and target adverts based on profiles generated using Facebook's user data.",
  }, {
    id: '_gat_UA-regex',
    // 'This cookie name is associated with Google Universal Analytics, according to documentation it is used for statistics.',
    regex: '_gat_UA-([0-9]{8})-([0-9]{2})'
  }, {
    id: '_gat_gtag_UA_-regex',
    // 'Google Analytics, used for storing unique user id.',
    regex: '_gat_gtag_UA_[0-9]+_[0-9]+'
  }, {
    id: 'mp_regex',
    // 'Cookie is placed by Mixpanel. Mixpanel is a company that produces user behavior analytics.',
    regex: 'mp_[a-f0-9]{32}_mixpanel'
  }, {
    id: 'gcl'
    // 'Ads targeting for Google and conversion tracking',
  }, {
    id: 'plaid_link_persistent_id'
    // 'Used by plaid for analytics',
  }, {
    id: '_fbp'
    // 'Used for attributing Facebook marketing',
  }])], ['delete-if-seen', buildOptimizedCategory('delete-if-seen', [{
    id: 'cloudflare-challenge-regex',
    // These cookies are used by Cloudflare for the execution of
    // Javascript or Captcha challenges. They are not used for tracking or
    // beyond the scope of the challenge. They can be deleted if seen.
    regex: '^(cf_chl_prog$)|(cf_cc_...$)|(cf_chl_cc_...$)|(cf_chl_seq_...$)'
  }])]]),
  geolocationRules: [{
    region: 'DEFAULT',
    framework: 'optOut'
  }, {
    region: 'EU',
    framework: 'optIn'
  }]
};

/**
 * Product level cookie manager configs
 */
const ProductLevelCookieManagerConfigs = new Map([['base', BaseCookieManagerConfig], ['coinbase', CoinbaseCookieManagerConfig], ['exchange', ExchangeCookieManagerConfig]]);

/**
 * Per-product optimized lookup structures
 * Structure: product -> cookieName -> category
 */
const productExactMatches = new Map();

/**
 * Per-product regex trackers
 * Structure: productName -> array of regex trackers
 */
const productRegexTrackers = new Map();

/**
 * Array for regex-based cookie patterns that need sequential testing
 */

/**
 * Initialize lookup structures for a specific product
 * @param productName - The product name to initialize
 * @param cookieManagerConfig - The cookie manager configuration for the product
 */
function initializeProductLookupStructures(productName, cookieManagerConfig) {
  // Initialize product-specific maps
  const exactMatches = new Map();
  const regexTrackers = [];

  // Build optimized lookup structures for this product
  for (const _ref of cookieManagerConfig.categories) {
    var _ref2 = _slicedToArray(_ref, 2);
    const categoryConfig = _ref2[1];
    // Copy exact matches
    for (const cookieName of categoryConfig.exactMatches) {
      exactMatches.set(cookieName, categoryConfig.id);
    }

    // Copy regex patterns
    for (const regexPattern of categoryConfig.regexMatches) {
      regexTrackers.push({
        regex: regexPattern.compiledRegex,
        category: categoryConfig.id,
        originalPattern: regexPattern.regex,
        trackerId: regexPattern.id
      });
    }
  }

  // Store in product-specific maps
  productExactMatches.set(productName, exactMatches);
  productRegexTrackers.set(productName, regexTrackers);
}

/**
 * Looks up the category for a given cookie name for a specific product
 * @param cookieName - The name of the cookie to look up
 * @param productName - The product name to use for lookup
 * @returns The category of the cookie
 * @throws Error if the cookie is not configured for the product
 */
function getCookieCategory(cookieName, productName = 'coinbase') {
  // First, check exact matches (O(1) lookup)
  const exactMatches = productExactMatches.get(productName);
  if (exactMatches) {
    const exactMatch = exactMatches.get(cookieName);
    if (exactMatch) {
      return exactMatch;
    }
  }

  // If no exact match, check regex patterns (O(k) where k is number of regex patterns)
  const regexTrackers = productRegexTrackers.get(productName);
  if (regexTrackers) {
    for (const regexTracker of regexTrackers) {
      if (regexTracker.regex.test(cookieName)) {
        return regexTracker.category;
      }
    }
  }

  // Throw error if cookie not configured
  throw new Error(`Cookie '${cookieName}' is not configured in the cookie manager config for product '${productName}'`);
}

/**
 * Initialize lookup structures for all registered products
 */
function initializeAllproducts() {
  for (const _ref3 of ProductLevelCookieManagerConfigs) {
    var _ref4 = _slicedToArray(_ref3, 2);
    const productName = _ref4[0];
    const config = _ref4[1];
    initializeProductLookupStructures(productName, config);
  }
}

// Initialize all products on module load
initializeAllproducts();

/**
 * Gets all cookies currently set in the browser
 * @returns An object with cookie names as keys and values as values
 */
function getAllCookies() {
  if (typeof document === 'undefined') {
    return {};
  }
  return Cookies.get() || {};
}

/* eslint-disable */
/**
 * Checks if a cookie has user consent based on its category
 * @param cookieName - The name of the cookie to check
 * @returns true if the cookie has consent or is required, false otherwise
 */
function hasConsent(cookieName, product) {
  // SSR safety check
  if (typeof window === 'undefined') {
    return false; // In SSR, assume no consent to be safe
  }
  try {
    const category = getCookieCategory(cookieName, product);

    // Delete-if-seen cookies should always be allowed to be removed
    if (category === 'delete-if-seen') {
      return false; // Return false so they get removed
    }

    // Necessary cookies always have consent
    if (category === 'necessary') {
      return true;
    }
    const preferences = JSON.parse(decodeURIComponent(Cookies.get(CONSENT_PREFERENCES_COOKIE)));
    return preferences[category] ?? false;
  } catch (error) {
    // If cookie is not configured, it should be removed (no consent)
    return false;
  }
}
function getHostname() {
  if (typeof window !== 'undefined') {
    return window.location?.hostname;
  }
  return undefined;
}
function getDomainWithoutSubdomain() {
  const hostname = getHostname();
  if (!hostname) {
    return undefined;
  }

  // Handle localhost
  if (hostname === 'localhost') return hostname;

  // Handle IP addresses (return as-is, no dot prefix)
  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return hostname;
  }

  // Handle domains
  const parts = hostname.split('.');
  if (parts.length <= 1) {
    return hostname;
  }

  // If it's already a top-level domain (e.g., "example.com")
  if (parts.length <= 2) {
    return `.${hostname}`;
  }

  // Remove subdomains to get the root domain (e.g., "app.example.com" → ".example.com")
  const rootDomain = parts.slice(-2).join('.');
  return `.${rootDomain}`;
}
function removeCookies(cookies) {
  if (typeof document === 'undefined') {
    return;
  }
  cookies.forEach(c => {
    Cookies.remove(c);
    if (Cookies.get(c)) {
      Cookies.remove(c, {
        domain: getDomainWithoutSubdomain(),
        path: '/'
      });
      Cookies.remove(c, {
        domain: getHostname(),
        path: '/'
      });
    }
  });
}

/**
 * Hook that monitors cookies and removes any that are not consented to by the user
 * Uses change-detection to only run expensive operations when cookies actually change
 */
function useRemoveUnauthorizedCookies(product) {
  const prevCookieRef = useRef('');
  useEffect(() => {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return () => {}; // Return empty cleanup function for SSR
    }
    const checkAndRemoveCookies = () => {
      const cookieValues = getAllCookies();
      const cookiesToRemove = [];
      Object.keys(cookieValues).forEach(cookieName => {
        // Always preserve OneTrust cookies
        if (cookieName === 'OptanonConsent' || cookieName === 'OptanonAlertBoxClosed') {
          return;
        }
        try {
          const category = getCookieCategory(cookieName, product);
          if (category === 'necessary') {
            return;
          }
          if (category === 'delete-if-seen') {
            cookiesToRemove.push(cookieName);
            return;
          }
        } catch (error) {
          // Cookie not configured - check consent
        }
        if (!hasConsent(cookieName, product)) {
          cookiesToRemove.push(cookieName);
        }
      });
      if (cookiesToRemove.length > 0) {
        removeCookies(cookiesToRemove);
      }
    };
    prevCookieRef.current = document.cookie;
    checkAndRemoveCookies();
    const interval = setInterval(() => {
      const currentCookie = document.cookie;
      if (currentCookie !== prevCookieRef.current) {
        prevCookieRef.current = currentCookie;
        checkAndRemoveCookies();
      }
    }, 500);
    return () => clearInterval(interval);
  }, [product]);
}

// Products supported across the package

const COINBASE_DEV_SCRIPT_ID = '01956191-791b-769a-8313-3683f5e22e0d-test';
const EXCHANGE_DEV_SCRIPT_ID = COINBASE_DEV_SCRIPT_ID;
const BASE_DEV_SCRIPT_ID = '0195f66c-28a2-7945-84d0-ae204720185d-test';

// Domain script IDs for each product
const DOMAIN_SCRIPT_IDS = {
  coinbase: {
    production: '01956191-791b-769a-8313-3683f5e22e0d',
    staging: COINBASE_DEV_SCRIPT_ID,
    development: COINBASE_DEV_SCRIPT_ID,
    mock: COINBASE_DEV_SCRIPT_ID
  },
  exchange: {
    production: '01956191-791b-769a-8313-3683f5e22e0d',
    staging: EXCHANGE_DEV_SCRIPT_ID,
    development: EXCHANGE_DEV_SCRIPT_ID,
    mock: EXCHANGE_DEV_SCRIPT_ID
  },
  prime: {
    production: COINBASE_DEV_SCRIPT_ID,
    staging: COINBASE_DEV_SCRIPT_ID,
    development: COINBASE_DEV_SCRIPT_ID,
    mock: COINBASE_DEV_SCRIPT_ID
  },
  custody: {
    production: COINBASE_DEV_SCRIPT_ID,
    staging: COINBASE_DEV_SCRIPT_ID,
    development: COINBASE_DEV_SCRIPT_ID,
    mock: COINBASE_DEV_SCRIPT_ID
  },
  cloud: {
    production: COINBASE_DEV_SCRIPT_ID,
    staging: COINBASE_DEV_SCRIPT_ID,
    development: COINBASE_DEV_SCRIPT_ID,
    mock: COINBASE_DEV_SCRIPT_ID
  },
  commerce: {
    production: COINBASE_DEV_SCRIPT_ID,
    staging: COINBASE_DEV_SCRIPT_ID,
    development: COINBASE_DEV_SCRIPT_ID,
    mock: COINBASE_DEV_SCRIPT_ID
  },
  base: {
    production: '0195f66c-28a2-7945-84d0-ae204720185d',
    staging: BASE_DEV_SCRIPT_ID,
    development: BASE_DEV_SCRIPT_ID,
    mock: BASE_DEV_SCRIPT_ID
  }
};

/**
 * Compares two Record<string, boolean> objects for deep equality
 * @param pref1 First preferences object
 * @param pref2 Second preferences object
 * @returns true if both objects have the same keys and values, false otherwise
 */
function arePreferencesEqual(pref1, pref2) {
  const keys1 = Object.keys(pref1);
  const keys2 = Object.keys(pref2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  return keys1.every(key => pref1[key] === pref2[key]);
}
const HOST_MAP = {
  development: 'https://consent-dev.cbhq.net',
  staging: 'https://consent-staging.cbhq.net',
  production: 'https://api.coinbase.com',
  mock: 'https://consent-dev.cbhq.net'
};
function getBaseURL(environment) {
  return HOST_MAP[environment];
}

// Get the consent preferences from the OneTrust active groups
function getConsentPreferences() {
  // Ensure OneTrust is available else send default strict preferences
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  if (typeof window === 'undefined' || !window?.OnetrustActiveGroups) {
    return {
      strictlyNecessary: true,
      performance: false,
      functional: false,
      targeting: false
    };
  }

  // OnetrustActiveGroups = e.g., "C0001,C0002"
  const activeGroups = (typeof window !== 'undefined' ? window.OnetrustActiveGroups?.split(',') : null) ?? [];
  return {
    strictlyNecessary: activeGroups.includes(CATEGORY_TO_CONSENT_MAP.necessary),
    performance: activeGroups.includes(CATEGORY_TO_CONSENT_MAP.performance),
    functional: activeGroups.includes(CATEGORY_TO_CONSENT_MAP.functional),
    targeting: activeGroups.includes(CATEGORY_TO_CONSENT_MAP.targeting)
  };
}
function getUserConsentPreferences() {
  const cookie = Cookies.get(CONSENT_PREFERENCES_COOKIE);
  if (!cookie) return {};
  return JSON.parse(decodeURIComponent(cookie));
}

/* eslint-disable consistent-return */

function setStickyCookie(preferences) {
  const expires = new Date(Date.now() + COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000).toUTCString();
  const value = encodeURIComponent(JSON.stringify(preferences));
  const domain = getDomainWithoutSubdomain();
  document.cookie = `cb_consent_preferences=${value}; path=/; expires=${expires}; SameSite=Lax; domain=${domain}`;
}

/**
 * React component that injects the OneTrust script into the document head
 * using React Helmet
 */
function CookieBanner({
  product = 'coinbase',
  onLoad,
  user,
  environment = 'production',
  deviceId,
  countryCode,
  isInEurope,
  locale,
  logEvent,
  onPreferencesChanged
}) {
  const hasMounted = useHasMounted();
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    jwtToken = _useState4[0],
    setJwtToken = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    jwtFetchFailed = _useState6[0],
    setJwtFetchFailed = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasLoggedConsentForUser = _useState8[0],
    setHasLoggedConsentForUser = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    lastAppliedLocale = _useState0[0],
    setLastAppliedLocale = _useState0[1];
  const domainScriptId = DOMAIN_SCRIPT_IDS[product][environment];
  const oneTrustScriptBaseUrl = `https://cdn.cookielaw.org/consent/${domainScriptId}`;

  // Memoized script arrays to avoid creating new arrays on every render
  const authenticatedUserScripts = useMemo(() => [{
    type: 'text/javascript',
    innerHTML: `
              window.OneTrust = window.OneTrust || {};
              window.OneTrust.dataSubjectParams = {
                id: "${user?.uuid}",
                isAnonymous: false,
                token: "${jwtToken}"
              };
            `
  }, {
    type: 'text/javascript',
    src: `${oneTrustScriptBaseUrl}/OtAutoBlock.js`
  }, {
    type: 'text/javascript',
    src: `${oneTrustScriptBaseUrl}/otSDKStub.js`,
    'data-domain-script': domainScriptId
  }, {
    type: 'text/javascript',
    innerHTML: `function OptanonWrapper() { 
          window.dispatchEvent(new Event('${ONETRUST_LOADED_EVENT}'));
        }`
  }], [user?.uuid, jwtToken, oneTrustScriptBaseUrl, domainScriptId]);
  const unauthenticatedUserScripts = useMemo(() => [{
    type: 'text/javascript',
    innerHTML: `
                window.OneTrust = window.OneTrust || {};
                window.OneTrust.dataSubjectParams = {
                  isAnonymous: true,
                };
              `
  }, {
    type: 'text/javascript',
    src: `${oneTrustScriptBaseUrl}/OtAutoBlock.js`
  }, {
    type: 'text/javascript',
    src: `${oneTrustScriptBaseUrl}/otSDKStub.js`,
    'data-domain-script': domainScriptId
  }, {
    type: 'text/javascript',
    innerHTML: `function OptanonWrapper() { 
          window.dispatchEvent(new Event('${ONETRUST_LOADED_EVENT}'));
        }`
  }], [domainScriptId, oneTrustScriptBaseUrl]);

  // Fetch JWT from the server
  useEffect(() => {
    if (!user || !hasMounted) return;
    let interval;
    const fetchJwt = async () => {
      try {
        const response = await fetch(`${getBaseURL(environment)}/api/v1/consent/token`, {
          method: 'POST',
          body: JSON.stringify({
            user_id: user.uuid
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        const jwt = data.jwt;
        setJwtToken(jwt);
        setJwtFetchFailed(false);
        interval = setInterval(() => {
          if (window.OneTrust?.syncConsentProfile) {
            window.OneTrust.syncConsentProfile(user.uuid, jwt, false);
            clearInterval(interval);
          }
        }, ONETRUST_SYNC_INTERVAL);
      } catch (err) {
        // Set flag to indicate JWT fetch failed, fallback to unauthenticated scripts
        setJwtFetchFailed(true);
        setJwtToken(null);
        // Error is handled silently to provide graceful fallback
      }
    };
    void fetchJwt();
    return () => clearInterval(interval);
  }, [environment, hasMounted, user]);
  const logConsent = useCallback(async customPreferences => {
    if (!user) return;
    const preferences = customPreferences ?? getUserConsentPreferences();
    await fetch(`${getBaseURL(environment)}/api/v1/consent/log`, {
      method: 'POST',
      body: JSON.stringify({
        consent: {
          userId: user.uuid,
          preferences,
          deviceId,
          locale,
          timestamp: Date.now(),
          product,
          userActivity: isInEurope ? 'opt-in' : 'opt-out',
          disclosureVersion: '1.0',
          disclosureLanguage: locale,
          region: countryCode,
          countryCode
        }
      })
    }).then(() => {
      if (logEvent) {
        logEvent('ucpm_consent_log', {
          action: ActionType.submit,
          componentType: ComponentType.banner,
          product,
          userActivity: isInEurope ? 'opt-in' : 'opt-out',
          userId: user?.uuid,
          preferences: JSON.stringify(preferences)
        });
      }
    });
  }, [countryCode, deviceId, environment, isInEurope, locale, logEvent, product, user]);

  // Log existing consent when user signs in from unauthenticated state
  useEffect(() => {
    if (!user || !hasMounted || hasLoggedConsentForUser) return;
    const currentPreferences = getConsentPreferences();
    const storedPreferences = getUserConsentPreferences();
    // Only log if there are stored preferences and they differ from current preferences
    if (Object.keys(storedPreferences).length > 0 && !arePreferencesEqual(currentPreferences, storedPreferences)) {
      // Log the stored preferences (what user consented to while unauthenticated)
      void logConsent(storedPreferences);
      // Update the cookie to current OneTrust preferences (OneTrust is source of truth going forward)
      setStickyCookie(currentPreferences);
      setHasLoggedConsentForUser(true);
    }
  }, [user, hasMounted, hasLoggedConsentForUser, logConsent]);

  // Reset consent logging flag when user changes
  useEffect(() => {
    setHasLoggedConsentForUser(false);
  }, [user?.uuid]);
  useEffect(() => {
    if (!hasMounted) return;
    const interval = setInterval(() => {
      if (window.OneTrust?.OnConsentChanged) {
        window.OneTrust.OnConsentChanged(() => {
          const preferences = getConsentPreferences();
          if (logEvent) {
            logEvent('ucpm_consent_changed', {
              action: ActionType.change,
              componentType: ComponentType.banner,
              product,
              preferences: JSON.stringify(preferences)
            });
          }
          if (onPreferencesChanged) onPreferencesChanged();
          setStickyCookie(preferences);
          void logConsent();
          // Only set the flag if we have a user (normal consent change with authenticated user)
          if (user) {
            setHasLoggedConsentForUser(true);
          }
        });
        clearInterval(interval);
      }
    }, ONETRUST_CALLBACK_INTERVAL);
    return () => clearInterval(interval);
  }, [environment, hasMounted, product, user, logConsent, logEvent, onPreferencesChanged]);
  useRemoveUnauthorizedCookies(product);
  const handleScriptLoad = useCallback(() => {
    if (logEvent) {
      logEvent('ucpm_banner_loaded', {
        action: ActionType.view,
        componentType: ComponentType.banner,
        product
      });
    }
    if (onLoad) onLoad();
  }, [logEvent, onLoad, product]);

  // Change the language of the OneTrust banner to the locale provided by upstream
  useEffect(() => {
    if (!hasMounted || !locale || locale === lastAppliedLocale) return;
    const interval = setInterval(() => {
      if (window.OneTrust?.changeLanguage) {
        window.OneTrust.changeLanguage(locale);
        setLastAppliedLocale(locale);
        clearInterval(interval);
      }
    }, ONETRUST_CALLBACK_INTERVAL);
    return () => clearInterval(interval);
  }, [hasMounted, locale, lastAppliedLocale]);
  useEffect(() => {
    window.addEventListener(ONETRUST_LOADED_EVENT, handleScriptLoad);
    return () => window.removeEventListener(ONETRUST_LOADED_EVENT, handleScriptLoad);
  }, [handleScriptLoad]);

  // This is to handle the default tracking preferences when the user has not yet interacted with the banner
  // using the region based policies
  useEffect(() => {
    if (Cookies.get(CONSENT_PREFERENCES_COOKIE)) return;
    let preferences = getConsentPreferences();
    // TODO: Handle Quebec for Canada same as Europe
    if (!isInEurope) {
      preferences = {
        strictlyNecessary: true,
        performance: true,
        functional: true,
        targeting: true
      };
    }
    setStickyCookie(preferences);
  }, [isInEurope]);
  if (!hasMounted) return null;
  return /*#__PURE__*/jsxs(HelmetProvider, {
    children: [user?.uuid && jwtToken && /*#__PURE__*/jsx(Helmet, {
      script: authenticatedUserScripts
    }), (!user?.uuid || user?.uuid && jwtFetchFailed) && /*#__PURE__*/jsx(Helmet, {
      script: unauthenticatedUserScripts
    })]
  });
}

/* eslint-disable */
const MAX_COOKIE_SIZE = 4;
function getByteLength(str) {
  return new TextEncoder().encode(str).length;
}
function isMaxKBSize(str, maxKB) {
  return getByteLength(str) / 1024 > maxKB;
}
function createSetCookie({
  name,
  product
}) {
  return (value, options) => {
    if (value === undefined || value === null) {
      Cookies.remove(name, options);
      return;
    }
    const category = getCookieCategory(name, product);

    // Handle delete-if-seen cookies
    if (category === 'delete-if-seen') {
      Cookies.remove(name, _objectSpread(_objectSpread({}, options), {}, {
        domain: getDomainWithoutSubdomain(),
        path: '/'
      }));
      Cookies.remove(name, _objectSpread(_objectSpread({}, options), {}, {
        domain: getHostname(),
        path: '/'
      }));
      return;
    }
    const cookieHasConsent = hasConsent(name, product);
    if (!cookieHasConsent) {
      // Skip setting cookie due to lack of consent
      return;
    }
    const stringValue = JSON.stringify(value);
    const cookieSize = options?.size ?? MAX_COOKIE_SIZE;
    if (isMaxKBSize(encodeURIComponent(stringValue) + name, cookieSize)) {
      throw new Error(`${name} value exceeds ${cookieSize}KB`);
    } else {
      const newOptions = _objectSpread(_objectSpread({}, options), {}, {
        domain: getDomainWithoutSubdomain(),
        path: '/'
      });
      if ('size' in newOptions) {
        delete newOptions.size;
      }
      Cookies.set(name, stringValue, newOptions);
    }
  };
}

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Hook that returns the value of a cookie and a function to set it
 * It only supports client-side cookies and does not support SSR
 * @param cookieName - The name of the cookie
 * @param product - Optional product name for cookie management
 * @returns A tuple containing the cookie value and a function to set it
 */
function useCookie(cookieName, product) {
  const setCookie = useCallback((value, options) => createSetCookie({
    name: cookieName,
    product
  })(value, options), [cookieName, product]);
  const parseCookieValue = rawValue => {
    if (!rawValue) {
      return undefined;
    }
    try {
      return JSON.parse(rawValue);
    } catch (error) {
      if (typeof rawValue === 'string') {
        return rawValue;
      }
      return undefined;
    }
  };
  const rawCookieValue = Cookies.get(cookieName);
  const cookieValue = parseCookieValue(rawCookieValue);
  return [cookieValue, setCookie];
}
function useIsBannerVisible() {
  const hasMounted = useHasMounted();
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isVisible = _useState10[0],
    setIsVisible = _useState10[1];
  const evaluateVisibility = useCallback(() => {
    if (typeof window === 'undefined') return;
    if (window.OneTrust && typeof window.OneTrust.IsAlertBoxClosed === 'function') {
      const isClosed = window.OneTrust.IsAlertBoxClosed();
      setIsVisible(!isClosed);
    }
  }, []);
  useEffect(() => {
    if (!hasMounted) {
      return () => {};
    }
    let isActive = true;
    const handleLoaded = () => {
      if (!isActive) return;

      // Evaluate visibility immediately
      evaluateVisibility();

      // Evaluate visibility subsequently
      if (window.OneTrust?.OnConsentChanged) {
        window.OneTrust.OnConsentChanged(() => {
          if (!isActive) return;
          evaluateVisibility();
        });
      }
    };
    if (typeof window.OneTrust?.IsAlertBoxClosed === 'function') {
      handleLoaded();
    }
    window.addEventListener(ONETRUST_LOADED_EVENT, handleLoaded);
    return () => {
      isActive = false;
      window.removeEventListener(ONETRUST_LOADED_EVENT, handleLoaded);
    };
  }, [evaluateVisibility, hasMounted]);
  return isVisible;
}
const CB_TEST_COOKIE = 'cb_test_cookie';

/**
 * Returns true if cookies are enabled, and false otherwise.
 * We set a test cookie and check to see if it's stored.
 * @returns {boolean}
 */
function areCookiesEnabled() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }
  try {
    Cookies.set(CB_TEST_COOKIE, '1');
    const enabled = Cookies.get(CB_TEST_COOKIE) === '1';
    Cookies.remove(CB_TEST_COOKIE);
    return enabled;
  } catch (e) {
    return false;
  }
}

/**
 * Gets a cookie by name
 * @param name - The name of the cookie to get
 * @returns The value of the cookie or undefined if the cookie is not set
 */
function getCookie(name) {
  if (typeof document === 'undefined') {
    return undefined;
  }
  return Cookies.get(name);
}
function openCookiePreferencesModal() {
  if (window?.OneTrust) {
    window.OneTrust.ToggleInfoDisplay();
  }
}
export { CATEGORY_TO_CONSENT_MAP, CB_TEST_COOKIE, CONSENT_PREFERENCES_COOKIE, COOKIE_EXPIRY_DAYS, CookieBanner, DOMAIN_SCRIPT_IDS, ONETRUST_CALLBACK_INTERVAL, ONETRUST_LOADED_EVENT, ONETRUST_SYNC_INTERVAL, areCookiesEnabled, arePreferencesEqual, createSetCookie, getAllCookies, getCookie, getDomainWithoutSubdomain, getHostname, getUserConsentPreferences, hasConsent, openCookiePreferencesModal, removeCookies, setStickyCookie, useCookie, useHasMounted, useIsBannerVisible, useRemoveUnauthorizedCookies };
//# sourceMappingURL=index.js.map
